import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SmartphoneIcon(props: IconProps) {
    return <Icon {...props} iconKey={"smartphone"}/>
}
